import { Component, OnInit } from '@angular/core';
import { ForgotPasswordService } from './forgot-password.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {
  notRobot: boolean;
  email: string;
  errorMessage: string;
  emailSent = false;

  constructor(private forgotPasswordService: ForgotPasswordService) {}

  ngOnInit(): void {}

  generatePassword() {
    if (this.notRobot) {
      this.forgotPasswordService.sendTokenMail(this.email).subscribe((response) => {
        this.emailSent = true;
      });
    }
  }

  resolved(captchaResponse: string) {
    console.log(captchaResponse);
    this.errorMessage = '';
    if (captchaResponse) {
      this.notRobot = true;
    }
  }
}
